import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-encabezado-detalle-orden',
  standalone: true,
  imports: [ButtonModule],
  template: `
    <div class="flex justify-between items-center gap-3 flex-wrap">
      <div>
        <h2 class="text-xl font-semibold text-gray-800 m-0">{{ titulo() }}</h2>
        <p class="text-sm text-gray-500 m-0">
          {{ breadcrumbModulo() }} > Orden {{ codigoOrden() || '-' }}
        </p>
      </div>

      <div class="flex flex-wrap gap-2">
        <button
          pButton
          type="button"
          label="Ver Detalle"
          icon="pi pi-building"
          class="p-button-outlined"
          (click)="verDetalle.emit()">
        </button>
        <button
          pButton
          type="button"
          label="Regresar"
          icon="pi pi-arrow-left"
          class="p-button-outlined"
          (click)="regresar.emit()">
        </button>
      </div>
    </div>
  `
})
export class EncabezadoDetalleOrdenComponent {
  titulo = input.required<string>();
  breadcrumbModulo = input.required<string>();
  codigoOrden = input<string | undefined>('');

  verDetalle = output<void>();
  regresar = output<void>();
}
